import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');
export const getRecentActivities = () => api.get('/dashboard/recent-activities');
export const getMonthlyStats = () => api.get('/dashboard/monthly-stats');
export const getMaintenanceCosts = () => api.get('/dashboard/maintenance-costs');
export const getVehicleEfficiency = () => api.get('/dashboard/vehicle-efficiency');

// Vehicles (Armada)
export const getVehicles = (params) => api.get('/vehicles', { params });
export const getVehicle = (id) => api.get(`/vehicles/${id}`);
export const createVehicle = (data) => api.post('/vehicles', data);
export const updateVehicle = (id, data) => api.put(`/vehicles/${id}`, data);
export const updateOdometer = (id, odometer) => api.put(`/vehicles/${id}/odometer?odometer=${odometer}`);
export const deleteVehicle = (id) => api.delete(`/vehicles/${id}`);

// Drivers (Sopir)
export const getDrivers = (params) => api.get('/drivers', { params });
export const getDriver = (id) => api.get(`/drivers/${id}`);
export const createDriver = (data) => api.post('/drivers', data);
export const updateDriver = (id, data) => api.put(`/drivers/${id}`, data);
export const deleteDriver = (id) => api.delete(`/drivers/${id}`);

// Trip Logs (Catatan Perjalanan)
export const getTrips = (params) => api.get('/trips', { params });
export const getTrip = (id) => api.get(`/trips/${id}`);
export const createTrip = (data) => api.post('/trips', data);
export const updateTrip = (id, data) => api.put(`/trips/${id}`, data);
export const completeTrip = (id, odometer, bbm) => api.put(`/trips/${id}/complete?odometer_kembali=${odometer}&konsumsi_bbm=${bbm}`);
export const deleteTrip = (id) => api.delete(`/trips/${id}`);

// Maintenance Schedules
export const getSchedules = (params) => api.get('/schedules', { params });
export const getSchedule = (id) => api.get(`/schedules/${id}`);
export const createSchedule = (data) => api.post('/schedules', data);
export const updateSchedule = (id, data) => api.put(`/schedules/${id}`, data);
export const deleteSchedule = (id) => api.delete(`/schedules/${id}`);
export const generateWorkOrderFromSchedule = (id) => api.post(`/schedules/${id}/generate-work-order`);

// Work Orders
export const getWorkOrders = (params) => api.get('/work-orders', { params });
export const getWorkOrder = (id) => api.get(`/work-orders/${id}`);
export const createWorkOrder = (data) => api.post('/work-orders', data);
export const updateWorkOrder = (id, data) => api.put(`/work-orders/${id}`, data);
export const deleteWorkOrder = (id) => api.delete(`/work-orders/${id}`);

// Notifications
export const getNotifications = (params) => api.get('/notifications', { params });
export const markNotificationRead = (id) => api.put(`/notifications/${id}/read`);
export const markAllNotificationsRead = () => api.put('/notifications/read-all');
export const deleteNotification = (id) => api.delete(`/notifications/${id}`);

// Reports
export const getMaintenanceSummary = () => api.get('/reports/maintenance-summary');
export const getCompletionRate = () => api.get('/reports/completion-rate');
export const getCostPerVehicle = () => api.get('/reports/cost-per-vehicle');
export const getFuelEfficiencyReport = () => api.get('/reports/fuel-efficiency');
export const getDocumentExpiryReport = () => api.get('/reports/document-expiry');

// Calendar
export const getCalendarEvents = (params) => api.get('/calendar/events', { params });

// Seed Data
export const seedDemoData = () => api.post('/seed-data');

export default api;
